import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  MotifButton,
  MotifDropdown,
  MotifDropdownItem,
  MotifIcon,
} from '@ey-xd/motif-react';
import { IconoirNavArrowDown } from '@ey-xd/motif-icon';
import { reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';

const MasterDataManagementTRSHeader = ({
  handleAddTRS,
  handleExportTRSImportTemplate,
  handleUploadTRSImportTemplate,
  handleDownloadMasterDataReport,
}) => {
  const [actionOptionsOpen, setActionOptionsOpen] = useState(false);

  return (
    <div className="row mt-3">
      <div className="col-md-2"> </div>
      <div className="col-md-10 d-flex justify-content-end">
        <div style={{ width: 'fit-content' }}>
          <MotifDropdown
            open={actionOptionsOpen}
            placement="bottom-end"
            id={'action-dropdown'}
            className="master-data-dropdown-action"
            handleClickOutside={() => setActionOptionsOpen(false)}
            trigger={
              <MotifButton
                type="button"
                variant="primary"
                onClick={() => setActionOptionsOpen(!actionOptionsOpen)}
                aria-controls={'action-dropdown'}
                id={'action-dropdown-trigger'}
                aria-expanded={actionOptionsOpen}
                aria-label="Action dropdown"
                data-testid="btnActions"
              >
                Actions{' '}
                <MotifIcon
                  iconFunction={IconoirNavArrowDown}
                  size="24"
                  fill="none"
                />
              </MotifButton>
            }
          >
            <ul role="menu">
              <li role="menuitem">
                <MotifDropdownItem
                  type="button"
                  onClick={handleAddTRS}
                  data-testid="btnAddTrs"
                  className="master-dropdown-item"
                >
                  Add TRS
                </MotifDropdownItem>
              </li>
              <li role="menuitem">
                <MotifDropdownItem
                  type="button"
                  onClick={handleExportTRSImportTemplate}
                  data-testid="btnExportTRSImportTemplate"
                  className="master-dropdown-item"
                >
                  Export TRS Import Template
                </MotifDropdownItem>
              </li>
              <li role="menuitem">
                <MotifDropdownItem
                  type="button"
                  onClick={handleUploadTRSImportTemplate}
                  data-testid="btnUploadTRSImportTemplate"
                  className="master-dropdown-item"
                >
                  Upload TRS Import Template
                </MotifDropdownItem>
              </li>
              <li role="menuitem">
                <MotifDropdownItem
                  type="button"
                  onClick={handleDownloadMasterDataReport}
                  data-testid="btnDownloadMasterDataReport"
                  className="master-dropdown-item"
                >
                  Download - Master Data Report (All Types)
                </MotifDropdownItem>
              </li>
            </ul>
          </MotifDropdown>
        </div>
      </div>
    </div>
  );
};

MasterDataManagementTRSHeader.propTypes = {
  handleAddTRS: PropTypes.func.isRequired,
  handleExportTRSImportTemplate: PropTypes.func.isRequired,
  handleUploadTRSImportTemplate: PropTypes.func.isRequired,
  handleDownloadMasterDataReport: PropTypes.func.isRequired,
};

export default connect((state) => ({
  bulkRollForwardFormValues: getFormValues('masterDataManagementTRSForm')(
    state
  ),
}))(
  reduxForm({ form: 'masterDataManagementTRSForm' })(
    MasterDataManagementTRSHeader
  )
);
